module.exports = __webpack_public_path__ + "img/scop9.bd81a4aa.jpg";